export const all = (source, predicate) => {
    for (const item of source) {
        if (predicate(item) === false) {
            return false;
        }
    }
    return true;
};
